module.exports = __webpack_public_path__ + "img/dispose7.73c81cac.png";